import type { ReactNode } from 'react';
import React from 'react';

import { expVal } from '@confluence/feature-experiments';
import { ProfileCardWrapper } from '@confluence/profile/entry-points/ProfileCardWrapper.ts';

export type AnalyticsProfileIdentityProps = {
	userId?: string | null;
	fullName?: string;
	children: ReactNode;
};

export const AnalyticsProfileIdentity = ({
	userId,
	fullName,
	children,
}: AnalyticsProfileIdentityProps): React.JSX.Element => {
	if (!expVal('ai_agent_analytics_cards', 'isEnabled', false) || !userId) {
		return <>{children}</>;
	}

	return (
		<ProfileCardWrapper userId={userId} fullName={fullName} trigger="click">
			{children}
		</ProfileCardWrapper>
	);
};
